
















import { Component, Vue, Prop } from 'vue-property-decorator';
import Toast from '@/components/display/toast.vue';
import { TransceiverService } from '@/services/transceiver-service';
import { Transceiver } from '@/api';

@Component({
	components: {},
})
export default class SetTransceiverDeploymentMode extends Vue {
	@Prop({ required: true, type: Object })
	public transceiver?: Transceiver | null;

	@Prop({ default: false, type: Boolean })
	public block!: boolean;

	public loading: boolean = false;

	private readonly transceiverService = new TransceiverService();
	private readonly toast = new Toast();

	public async setDeploymentMode() {
		if (this.transceiver?.id == null) {
			return;
		}
		this.loading = true;
		const { errorMessage } = await this.transceiverService.setDeploymentMeshMode(
			this.transceiver.id!,
		);
		this.loading = false;
		if (errorMessage != null) {
			this.toast.makeToast(errorMessage, 'Error', 'danger', true);
			return;
		}
		this.toast.makeToast(
			'The transceiver deployment mode message has been sent',
			'Success',
			'success',
		);
	}
}
